module.exports = __webpack_public_path__ + "static/media/GenralConsern.d8401573.svg";